import { createAction } from '@reduxjs/toolkit'
export const filtersOnUpdate = createAction('filters/onUpdate');
export const onFilterByUpdate = createAction('filters/onFilterByUpdate');
export const onSortCriteriaUpdate = createAction('filters/onSortCriteriaUpdate');
export const onParamsUpdate = createAction('filters/onParamsUpdate');
export const onResetTotal = createAction('filters/onResetTotal');
export const onPageChange = createAction('filters/onPageChange');
export const onViewChange = createAction('filters/onViewChange');
